function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHbar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,328.005,-1700.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-2.1527e-16,1.17188,-1.17188,-2.1527e-16,271.995,1700.4)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.21127,0,-108.171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.915,170.666L73.915,512L13.39,512C6,512 0,506 0,498.61L0,184.056C0,176.666 6,170.666 13.39,170.666L73.915,170.666Z",
    style: {
      fill: "rgb(2,219,140)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.21127,0,-108.171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.915,512L73.915,170.666L91.431,170.666C98.821,170.666 104.821,176.666 104.821,184.056L104.821,498.61C104.821,506 98.821,512 91.431,512L73.915,512Z",
    style: {
      fill: "rgb(0,172,109)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.916563,407.179,42.7196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.915,170.666L73.915,512L13.39,512C6,512 0,506 0,498.61L0,184.056C0,176.666 6,170.666 13.39,170.666L73.915,170.666Z",
    style: {
      fill: "rgb(253,156,76)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.916563,407.179,42.7196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.915,512L73.915,170.666L91.431,170.666C98.821,170.666 104.821,176.666 104.821,184.056L104.821,498.61C104.821,506 98.821,512 91.431,512L73.915,512Z",
    style: {
      fill: "rgb(255,127,22)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.880757,137.932,61.0524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.915,170.666L73.915,512L13.39,512C6,512 0,506 0,498.61L0,184.056C0,176.666 6,170.666 13.39,170.666L73.915,170.666Z",
    style: {
      fill: "rgb(61,87,211)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,0.880757,137.932,61.0524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.915,512L73.915,170.666L91.431,170.666C98.821,170.666 104.821,176.666 104.821,184.056L104.821,498.61C104.821,506 98.821,512 91.431,512L73.915,512Z",
    style: {
      fill: "rgb(31,63,217)"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.5,272.68,-255.998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.915,170.666L73.915,512L13.39,512C6,512 0,506 0,498.61L0,184.056C0,176.666 6,170.666 13.39,170.666L73.915,170.666Z",
    style: {
      fill: "rgb(240,0,180)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1.5,272.68,-255.998)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.915,512L73.915,170.666L91.431,170.666C98.821,170.666 104.821,176.666 104.821,184.056L104.821,498.61C104.821,506 98.821,512 91.431,512L73.915,512Z",
    style: {
      fill: "rgb(200,10,152)"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHbar);
export default __webpack_public_path__ + "static/media/hbar.93840b71f3fbd2d82e962a5a24f303d4.svg";
export { ForwardRef as ReactComponent };